import { render, staticRenderFns } from "./CustomersSubscriptionReminder.vue?vue&type=template&id=7e2cc40c"
import script from "./CustomersSubscriptionReminder.vue?vue&type=script&lang=js"
export * from "./CustomersSubscriptionReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports